import { render, staticRenderFns } from "./brand-collect.vue?vue&type=template&id=68446bc6"
import script from "./brand-collect.vue?vue&type=script&lang=js"
export * from "./brand-collect.vue?vue&type=script&lang=js"
import style0 from "./brand-collect.vue?vue&type=style&index=0&id=68446bc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports